import React from 'react';
import moment from 'moment';
import styled from 'styled-components';
import {
  Paper, Typography,
} from '@mui/material';
import { Container } from '../../components/Calendar/EventModal/EventModalCard/CardTypes/card.style';
import { i18n } from '../../translate/i18n';
import iconSuitable from '../../assets/certo.svg';
import iconNotSuitable from '../../assets/erro.svg';
import iconNA from '../../assets/meio.svg';

const branchWidth = 25;
const branchBorderSize = 4;
const bulletSize = 12;

const styles = {
  nameContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexWrap: 'wrap',
  },
  labelDocType: {
    fontSize: 12,
  },
  labelStatus: {
    fontSize: 12,
    fontWeight: 'bold',
  },
  title: {
    fontSize: '1.2rem',
    color: 'green',
  },
  date: {
    fontSize: '0.9rem',
  },
  branch: {
    width: branchWidth,
    backgroundColor: 'grey',
  },
  bullet: {
    width: bulletSize,
    height: bulletSize,
    backgroundColor: 'grey',
    borderRadius: bulletSize,
    margin: (-bulletSize / 2) - branchBorderSize / 2,
  },
  triangle: {
    width: 0,
    height: 0,
    borderStyle: 'solid',
    borderWidth: '15px 0 15px 15px',
    borderColor: 'transparent transparent transparent #fff',
    filter: 'drop-shadow(2px 0 0 #e6e6e6) drop-shadow(0 0.5px 0 #e6e6e6)',
    marginLeft: -2,
  },
  responsibleTitle: {
    fontSize: '0.8rem',
    fontWeight: 'bolder',
  },
  responsibleContent: {
    fontSize: '1rem',
  },
  footer: {
    marginTop: '0.25rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    fontSize: '0.7rem',
  },
  equipmentName: {
    fontSize: '1rem',
    fontWeight: 'bold'
  },
  descriptionContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  label: {
    color: "#828282",
    fontSize: "0.8rem"
  },
  dataContainer: {
    marginTop: 10
  },
  data: {
    marginTop: -3,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    direction: 'rtl',
    textAlign: 'left'
  },
  ansContainer: {
    display: 'flex',
  },
  ansContent: {
    display: 'flex',
    alignItems: 'center',
    marginRight: '0.5rem',
  },
  iconChecklist: {
    width: '1.25rem',
    marginRight: '0.25rem',
  },
};

export default function Card(props) {
  const containerStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRight: props.index % 2 === 0 && `${branchBorderSize}px solid grey`,
    marginRight: props.index % 2 === 0 && `calc(25rem + ${branchWidth - branchBorderSize}px)`,
    borderLeft: props.index % 2 === 1 && `${branchBorderSize}px solid grey`,
    marginLeft: props.index % 2 === 1 && `calc(25rem + ${branchWidth - branchBorderSize}px)`,
    boxSizing: 'border-box',
    marginTop: '-2rem',
  };

  return (
    <div style={containerStyle}>
      {props.index % 2 === 1
        && (
          <>
            <div style={styles.bullet} />
            <div style={styles.branch} />
          </>
        )
      }
      <PaperStyled onClick={props.click}>
        <Container statusColor="green" style={{ marginBottom: 0 }}>
          <div style={styles.nameContainer}>
            <div style={styles.dataContainer}>
              <div style={styles.data}>{props.equipmentService.serviceType.name} ({props.equipmentService.frequency.name})</div>
            </div>
            <span style={{ ...styles.date }}>{props.date && moment(props.date).format('DD/MM/YYYY')}</span>
          </div>

          <div style={styles.dataContainer}>
            <div style={styles.label}>Checklist</div>
            <div>
              <div style={styles.ansContainer}>
                <div style={styles.ansContent}>
                  <img src={iconSuitable} style={styles.iconChecklist} />
                  <div>
                    {props.questions && props.questions.filter(ans => ans.type === 'question' && ans.answer === 'YES').length}</div>
                </div>
                <div style={styles.ansContent}>
                  <img src={iconNotSuitable} style={styles.iconChecklist} />
                  <div>{props.questions && props.questions.filter(ans => ans.type === 'question' && ans.answer === 'NO').length}</div>
                </div>
                <div style={styles.ansContent}>
                  <img src={iconNA} style={styles.iconChecklist} />
                  <div>{props.questions && props.questions.filter(ans => ans.type === 'question' && ans.answer === 'NA').length}</div>
                </div>
              </div>
            </div>
          </div>
          <div style={styles.dataContainer}>
            <div style={styles.label}>{i18n.t('divCardTimeline.inspected_by')}</div>
            <div style={styles.data}>{props.inspectedBy && props.inspectedBy.name}</div>
          </div>
        </Container>
      </PaperStyled>
      {
        props.index % 2 === 0
        && (
          <>
            <div style={styles.branch} />
            <div style={styles.bullet} />
          </>
        )
      }
    </div>
  );
}

const PaperStyled = styled(Paper)`
  &:hover {
    box-shadow: 0px 0px 10px #bbb !important;
  };
  width: 25rem;
  border: 1px solid #ddd;
  cursor: pointer;
  overflow: hidden;
  opacity: ${props => (props.spinner ? 0.5 : 1)};
  margin-bottom: 40px;
`;
